import _isUndefined from 'lodash.isundefined';

import { isObject } from '../isObject';

/**
 * Removes undefined fields from an object
 * @param {Object} data - Data object
 * @param {boolean} [deep=true] - Also remove values from nested objects
 * @returns {Object}
 */
export const removeUndefined = (data, deep = true) =>
  Object.entries(data).reduce(
    (acc, [k, v]) =>
      _isUndefined(v) ? acc : { ...acc, [k]: deep && isObject(v) ? removeUndefined(v, deep) : v },
    {}
  );
